import { post } from '../util/http';
import { ENDPOINTS } from '../util/endpoints';

export const authService = {
  signIn:        (data) => post(ENDPOINTS.auth.signIn, data),
  sendOtp:       (data) => post(ENDPOINTS.auth.otp.send, data),
  verifyOtp:     (data) => post(ENDPOINTS.auth.otp.verify, data),
  resetPassword: (data) => post(ENDPOINTS.auth.otp.resetPassword, data),
};
